/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
export function crearCookie(name, value, expirationDateInMs) {
  console.log("expires", expirationDateInMs)

  const expirationDate = new Date();
  expirationDate.setTime(expirationDateInMs);

  document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  console.log("Cookie expirará en UTC:", expirationDate.toUTCString());
  console.log("Cookie created:", document.cookie);
}